export default "__VITE_ASSET__BSUSzeQ4__"